import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Footer from "../component/Footer/Footer";
import Logo from "../assets/company-logo.png";
import BackIcon from "../assets/left.png";
import Spinner from "../component/Spinner/Spinner";
import axiosApiFunction from "../utils/axiosapifunc";
import { showApiErrorToast } from "../utils/toastHelper";
import { decryptData, parseDecryptedData } from "../utils/decryptparams";
import "./RefundAndCancellation.css";

function RefundAndCancellation() {
    const navigate = useNavigate();
    // const id = localStorage.getItem("encryptedData");
    const [isLoading, setIsLoading] = useState(true);
    const [storeDetails, setStoreDetails] = useState({});
    const { id } = useParams();
    const encodedId = encodeURIComponent(id);

    const handleBack = () => {
        if (encodedId === null) {
            navigate("/");
        } else {
            navigate(`/${encodedId}`);
        }
    };

    useEffect(() => {
        const fetchStoreDetails = async () => {
            if (!id) {
                setIsLoading(false);
                window.location.href = "https://www.billberrypos.com/";
                return;
            }
            try {
                setIsLoading(true);

                const decryptedData = decryptData(id);

                if (!decryptedData) {
                    throw new Error("Decrypted data is empty or undefined");
                }
                
                const parsed = parseDecryptedData(decryptedData);

                try {
                    const storeDetails = await axiosApiFunction('get', '/api/v1/getstoredetails', { companyid: parsed.cid, locationid: parsed.lid }
                    );
                    
                    setStoreDetails(storeDetails.data[0]);
                }
                catch (err) {
                    showApiErrorToast('/api/v1/getstoredetails', err, 'Failed to fetch store details');
                    console.log(err);
                    navigate(`/${encodedId}`);
                } finally {
                    setIsLoading(false);
                }
            } catch (err) {
                console.log(err);
                navigate(`/${encodedId}`);
            } finally {
                setIsLoading(false);
            }
        };

        fetchStoreDetails();
    }, [id]);

    if (!id) {
        return null;
    }

    if (isLoading || !storeDetails) {
        return <Spinner enabled={true} />;
    }

    return (
        <div>
            <div className="refund-container">
                <div className="static-page-back">
                    <img src={BackIcon} alt="Back" onClick={handleBack} />
                </div>
                <div className="logo-container">
                    <img src={Logo} alt="Company Logo" className="company-logo" />
                </div>
                <h1 className="refund-title">Refund and Cancellation</h1>

                {/* <ol className="refund-list">
                    <p>Welcome to La Milano Pizzeria, brand owned by MFW Foods Private Limited. If you are not entirely satisfied with your purchase, we're here to help. This is a platform where direct business owners (our partners whom you order are La Milano Pizzeria Franchises) are solely responsible for the initiating refund process. Once order placed it cann't be cancelled or refunded. However in certain cases our partners can refund for which you can directly contact them where their contact number is shared upon successful order from your side.</p>
                </ol> */}
                <ol className="refund-list">
                    <p>
                        Thanks for shopping at <strong>https://order.billberrypos.com</strong>
                    </p>
                    <p>
                    This platform is functional for "{storeDetails?.name}" for Brand "{storeDetails?.companyname}".
                    </p>
                </ol>
                <h2 className="refund-subtitle">Cancellation Policy</h2>
                <ol className="refund-list">
                    <li>
                        If you are not entirely satisfied with your purchase, we're here to help.
                        This is a platform where direct business owners (our partners whom you
                        order) will be solely responsible for the initiating refund process. Once
                        order placed it cann't be cancelled or refunded. However in certain cases
                        our partners can refund for which you can directly contact them where their
                        contact number is shared upon successful order from your side.
                    </li>
                    <li>
                        We will contact on the phone number/ e-mail id provided to Us upon You
                        placing an order to confirm the details of the order, the price paid/ to be
                        paid and estimated delivery time wherever possible. You shall not be
                        entitled to cancel the order once You have received the above confirmation
                        from Us. If an Item You ordered is unavailable post confirmation of the
                        order, We will inform You of such unavailability. In which case:
                    </li>
                    <ol>
                        <li>
                            If You have made the payment: You will be entitled to cancel the order
                            and refund of the full amount paid for the Services.
                        </li>
                        <li>
                            If You opted for Cash on Delivery/Pay at Counter: You will be entitled to cancel the
                            order.
                        </li>
                        <li>We reserve Our sole right to cancel Your order if:</li>
                        <li>We cannot reach You to confirm the order.</li>
                        <li>
                            The delivery address provided by You is not within the Places of
                            Service.
                        </li>
                        <li>
                            Failure to deliver your order due to the lack of necessary information.
                        </li>
                        <li>Unavailability of the Items ordered.</li>
                    </ol>
                </ol>
                <h2 className="refund-subtitle">Refunds</h2>
                <ol className="refund-list">
                    <p>
                        You will receive the credit within a certain amount of days, depending on
                        your card issuer's policies. The refunds will be issued to the same payment
                        method which was used at the time of purchase.
                    </p>
                    <table className="refund-table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Payment Method</th>
                                <th>Refund Method</th>
                                <th>Refund Time-frame</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>Credit Card/ Debit Card</td>
                                <td>Credit Card/ Debit Card</td>
                                <td>5-7 business days</td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Net Banking</td>
                                <td>Net Banking Account (Credited to Bank Account)</td>
                                <td>5-7 business days</td>
                            </tr>
                        </tbody>
                    </table>
                    <p>
                    If the standard time-frame as mentioned above has passed and you have still not received the refund, please contact your credit or debit card issuer or your bank for more information.
                    </p>
                    <p>
                    If you have any questions about our Returns and Refunds Policy, please contact directly to the partner whom you ordered. AITL will take no responsibilities or liabilities for other partners.
                    </p>
                    <p>
                    AITL makes best possible efforts to provide quality products and services. 
                    </p>
                </ol>
            </div>
            <Footer />
        </div>
    );
}

export default RefundAndCancellation;
